<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div
        class="ts-w-auto ts-pt-3 ts-bg-gray-800 ts-rounded-lg ts-overflow-hidden ts-h-full"
      >
        <div class="ts-flex ts-justify-between ts-items-center">
          <span
            class="ts-uppercase ts-font-semibold ts-text-xl ts-px-4 ts-font-heading-font ts-whitespace-no-wrap  ts-text-yellow-600 md:ts-text-base"
          >
            {{ $t('gameBetting.gameType') }}
          </span>
          <a
            href="#"
            class="hover:ts-no-underline ts-mr-3"
            @click.prevent="refresh"
          >
            <i class="fas fa-sync-alt" v-if="!loading"></i>
            <i class="fas fa-sync fa-spin fa-spinner" v-else></i>
          </a>
        </div>
        <div class="ts-mt-4">
          <ul class="ts-space-y-4">
            <li
              @click.prevent="selectedType(2)"
              class="ts-px-6 ts-transaction ts-duration-150 ts-cursor-pointer ts-bg-gray-600"
            >
              <a href="#" class="hover:ts-no-underline">
                <span
                  class="ts-font-heading-font ts-text-white ts-tracking-widest ts-font-semibold ts-text-xl"
                  >5D</span
                >
              </a>
              <a href="#" class="ts-text-red-600"></a>
            </li>
            <li>
              <ul class="ts-ml-10 ts-space-y-3 ts-mt-2">
                <li v-for="(f, index) in fiveD" :key="index">
                  <a
                    href="#"
                    @click.prevent="selectedGame(f)"
                    class="ts-font-pacifico ts-text-base"
                    :class="
                      f.game_set_id == game_set_id ? 'ts-text-yellow-500' : ''
                    "
                    >{{ f.game_set_name }}</a
                  >
                </li>
              </ul>
            </li>
            <li
              @click.prevent="selectedType(1)"
              class="ts-px-6 ts-transaction ts-duration-150 ts-cursor-pointer ts-bg-gray-600 ts-mt-3"
            >
              <a href="#" class="hover:ts-no-underline">
                <span
                  class="ts-font-heading-font ts-text-white ts-tracking-widest ts-font-semibold ts-text-xl"
                  >6/49</span
                >
              </a>
            </li>
            <li>
              <ul class="ts-ml-10 ts-space-y-3 ts-mt-2">
                <li v-for="(f, index) in sixFortyNine" :key="index">
                  <a
                    href="#"
                    @click.prevent="selectedGame(f)"
                    class="ts-font-pacifico ts-text-base"
                    :class="
                      f.game_set_id == game_set_id ? 'ts-text-yellow-500' : ''
                    "
                    >{{ f.game_set_name }}</a
                  >
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'gameType',
  data() {
    return {
      loading: false,
      game_set: [],
      game_set_id: null
    }
  },
  computed: {
    fiveD() {
      if (!this.game_set.length > 0) {
        return []
      }
      return this.game_set.filter(el => el.game_setting.game_type_id == 2)
    },
    sixFortyNine() {
      if (!this.game_set.length > 0) {
        return []
      }
      return this.game_set.filter(el => el.game_setting.game_type_id == 1)
    }
  },
  created() {
    this.fetchGameSet()
  },
  methods: {
    ...mapActions('game/gameBetting', ['getGameSet']),
    fetchGameSet() {
      this.loading = true
      this.getGameSet({
        filter: {
          current_date: new Date(),
          time_available: new Date()
        }
      })
        .then(response => {
          this.game_set = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    selectedGame(value) {
      this.game_set_id = value.game_set_id
      this.$emit('game', value)
    },
    refresh() {
      this.fetchGameSet()
      this.game_set_id = null
      this.$emit('clearInput')
    }
  }
}
</script>
